module.exports = __webpack_public_path__ + "img/hands-joined-team.469b36a0.webp";